import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TaxonomyComponent} from './taxonomy.component';
import {EffectsModule} from '@ngrx/effects';
import {TaxonomyEffects} from './taxonomy.effects';
import {MatTreeModule} from '@angular/material/tree';
import {MaterialModule} from '../material.module';
import {
  SegmentAttachToTaxonomyModalComponent
} from './segment-attach-to-taxonomy-modal/segment-attach-to-taxonomy-modal.component';
import {SharedModule} from '../shared.module';
import {TaxonomyEditComponent} from './taxonomy-edit/taxonomy-edit.component';
import {TaxonomyDocumentationComponent} from './taxonomy-documentation/taxonomy-documentation.component';
import {TaxonomyFiltersComponent} from './taxonomy-filters/taxonomy-filters.component';
import {TaxonomyCreateComponent} from './taxonomy-create/taxonomy-create.component';
import {SegmentModule} from '../segment/segment.module';
import {StoreModule} from '@ngrx/store';
import {taxonomyFeatureKey, taxonomyReducer} from './taxonomy.reducer';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';


@NgModule({
  declarations: [
    TaxonomyComponent,
    SegmentAttachToTaxonomyModalComponent,
    TaxonomyEditComponent,
    TaxonomyDocumentationComponent,
    TaxonomyFiltersComponent,
    TaxonomyCreateComponent
  ],
    imports: [
        CommonModule,
        StoreModule.forFeature(taxonomyFeatureKey, taxonomyReducer),
        EffectsModule.forFeature([TaxonomyEffects]),
        MatTreeModule,
        MaterialModule,
        SharedModule,
        SegmentModule,
        MatProgressSpinnerModule
    ]
})
export class TaxonomyModule {
}
